class Product {
	static resolveImageUrl(url) {
		if (!url) return '';
		if (url.startsWith('http://') || url.startsWith('https://')) {
			return url;
		}
		return `${process.env.ROVERPIX_API}${url}`;
	}

	static getImageUrl(productId) {
		return `${process.env.ROVERPIX_API}/api/v1/product/image/${productId}`;
	}

	static getImages(product = {}, galleryImages = []) {
		const { id, name } = product;

		if (galleryImages.length > 0) {
			return galleryImages.map((image, index) => ({
				id: `${id}-${image.filename || index}`,
				url: Product.resolveImageUrl(image.url),
				alt: name,
			}));
		}

		if (id) {
			return [{
				id,
				url: Product.getImageUrl(id),
				alt: name,
			}];
		}

		return [];
	}

	static formatPrice(price = 0) {
		const amount = Number(price) || 0;
		return `R$ ${amount.toFixed(2).replace('.', ',')}`;
	}
}

export default Product;
